/* eslint-disable no-undef */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import webHttpService from "../../websiteComponent/apiServices/webHttpService";
import { showGlobalAlert } from "../../websiteComponent/commonComponent/useGlobalAlert";

export const getBanners = createAsyncThunk("getBanners", async (formData) => {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/getBanners`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
});

export const getCategories = createAsyncThunk("getCategories", async () => {
  try {
    const { data } = await webHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}/user/getCategories`
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
});

export const getOffers = createAsyncThunk("getOffers", async (formData) => {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/getOffers`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
});

export const getMyProfile = createAsyncThunk("getMyProfile", async () => {
  try {
    const { data } = await webHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}/user/getMyProfile`
    );

    return { data };
  } catch (error) {
    if (error.response) {
      showGlobalAlert(error.response.data.message);
    }

    return { error };
  }
});

// export const getOfferDetail = createAsyncThunk(
//   "getOfferDetail",
//   async (formData) => {
//     try {
//       const { data } = await webHttpService.post(
//         `${process.env.REACT_APP_APIENDPOINT}/user/getOfferDetail`,
//         formData
//       );
//

//       return { data };
//     } catch (error) {
//       if (error.response) showGlobalAlert(error.response.data.message);
//       return { error };
//     }
//   }
// );

export const getApiInfo = createSlice({
  name: "getApiInfo",
  initialState: {
    banner: [],
    category: [],
    offer: [],
    details: "",
    profile: {},
    currentLangCode: "en",
    dummyFile: [],
    loading: false,
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.banner = [];
      state.category = [];
      state.offer = [];
      state.details = "";
      state.profile = {};
      state.currentLangCode = "en";
      state.loading = false;
      state.error = null;
      state.dummyFile = [];
    },
    resetProfile: (state) => {
      console.log("yessssssssss");
      state.profile = {};
      state.currentLangCode = "en";
    },
    favData: (state, action) => {
      state.offer.offers = action.payload;
    },
    chatMedia: (state, action) => {
      state.dummyFile = action.payload;
    },

    setLikeSettings: (state, action) => {
      const fav = state.offer.offers.map((item) => {
        if (item._id === action.payload) {
          item.isLiked = !item.isLiked;
        }
        return item;
      });

      state.offer.offers = fav;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBanners.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBanners.fulfilled, (state, action) => {
        state.loading = false;
        state.banner = action.payload.data.results.banners;
      })
      .addCase(getBanners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.data.message;
      })
      .addCase(getCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.category = action.payload.data.results.categories;
      })
      .addCase(getCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.data.message;
      })
      .addCase(getOffers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOffers.fulfilled, (state, action) => {
        state.loading = false;

        if (
          (action.meta.arg.search ||
            action.meta.arg.categoryId ||
            action.meta.arg.page === 1) &&
          !action.meta.arg.index
        ) {
          state.offer = action.payload.data.results;
        } else {
          state.offer.offers = [
            ...state.offer.offers,
            ...action.payload.data.results.offers,
          ];
          state.offer.page = action.payload.data.results.page;
        }
      })
      .addCase(getOffers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.data.message;
      })
      .addCase(getMyProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMyProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload.data.results.user;
      })
      .addCase(getMyProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.data.message;
      });

    // [getOfferDetail.pending]: (state) => {
    //   state.loading = true;
    // },
    // [getOfferDetail.fulfilled]: (state, action) => {
    //   state.loading = false;

    //   document.title = action.payload.data.results.offer?.title;
    //   state.details = action.payload.data.results.offer;
    //   let time = action.payload.data.results.offer;
    //   const date1 = new Date(time.createdAt);
    //   const date2 = Date.now();
    //   const diffTime = Math.abs(date2 - date1);
    //   const diffsec = Math.floor(diffTime / 1000);
    //   let diff = diffsec < 1 ? "Just now" : `${diffsec} seconds ago`;
    //   if (diffsec > 59) {
    //     const diffmin = Math.floor(diffTime / (1000 * 60));

    //     diff = `${diffmin} minutes ago `;

    //     if (diffmin > 59) {
    //       const diffhrs = Math.floor(diffTime / (1000 * 60 * 60));
    //       diff = `${diffhrs} hours ago `;

    //       if (diffhrs > 23) {
    //         const diffdays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    //         diff = `${diffdays} days ago `;
    //       }
    //     }
    //   }
    //   time.time = diff;
    // },
    // [getOfferDetail.rejected]: (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload.data.message;
    // },
  },
});

export const { reset, favData, chatMedia, resetProfile, setLikeSettings } =
  getApiInfo.actions;
export default getApiInfo.reducer;
